import React, { useContext } from 'react';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { TextLayerContext } from '../context';

type Props = {
    layer: ILayerProps;
};

export const ShadowDef: React.FC<Props> = ({ layer }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const { id } = layer;
    const layerData = layer.data as ITextLayerProps;
    const { textShadow = [] } = layerData;

    if (!textShadow || textShadow.length === 0) return null;

    return (
        <React.Fragment>
            {textShadow.map((shadow, index) => (
                <filter
                    key={`shadow-defs-${id}-${index}`}
                    id={`shadow-${id}-${index}-${defIDSuffix}`}
                    x="-50%"
                    y="-50%"
                    width="200%"
                    height="200%"
                >
                    <feDropShadow
                        dx={shadow.x || 0}
                        dy={shadow.y || 0}
                        stdDeviation={shadow.blur / 2}
                        floodColor={shadow.color}
                    />
                </filter>
            ))}
        </React.Fragment>
    );
};
